import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, Input, Label } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'reactstrap'; 

//import images
import avatar1 from '../../../assets/images/users/avatar-1.jpg';
import Loader from '../Loader';
import { useNavigate } from 'react-router-dom';
import { fileToBase64 } from '../../../slices/layouts/utils';
import { CREATE_WORKFLOW_BLANK, FETCH_WORKFLOW_CATEGORY_LIST_BY_GROUP_ID } from '../../../slices/thunks';
import Custom_Loader from '../Custom_Loader';

const Create_New_WorkFlow_Dashboard = () => {
  const [user_avatar, setuser_avatar] = useState(null);
  const [user_avatar_file, setuser_avatar_file] = useState(null);
  const [dashboard_logo, set_dashboard_logo] = useState(null);
  const [modal_standard, setmodal_standard] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [description, setDescription] = useState('');
  const [dashboardName, setDashboardName] = useState('');
  const group_details = useSelector((state)=>state.Group_List)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const tog_standard = () => setmodal_standard(!modal_standard);
  const [workflow_category, setworkflow_category] = useState(null)
  const { workflow_listing_loader , workflow_category_by_group} = useSelector((state)=>{
         return state.WorkFlowBuilder
      })


  useEffect(() => {
    if(group_details?.groupList[0]?.Group_ID)
    setSelectedGroup(group_details?.groupList[0].Group_ID)
  }, [group_details])

  useEffect(() => {
      dispatch(FETCH_WORKFLOW_CATEGORY_LIST_BY_GROUP_ID({ group_id:selectedGroup }))
  }, [selectedGroup])
  

  return (
    <>
      <Button onClick={tog_standard}>Create workflow</Button>

      <Modal id="myModal" isOpen={modal_standard} toggle={tog_standard}>
  <ModalHeader className="modal-title" id="myModalLabel" toggle={tog_standard}>
    Create A New Workflow 
  </ModalHeader>

  <ModalBody>
    <Form onSubmit={(e) => {
      e.preventDefault();
      // Add form validation or API submission logic here
      // console.log({
      //   dashboardName,
      //   selectedGroup,
      //   user_avatar_file,
      //   dashboard_logo,
      //   // description,
      //   // category: ...
      // });



    const formData = new FormData();

    // Append manually managed fields (not directly in DOM inputs)
    formData.append("workflow_title", dashboardName);
    formData.append("group_id", selectedGroup);
    formData.append("type","basic")
    formData.append("category", workflow_category)
    
    if (user_avatar_file) {
      formData.append("workflow_logo", user_avatar_file);
    }
    // if (dashboard_logo) {
    //   formData.append("logo_base64", dashboard_logo);
    // }



      dispatch(CREATE_WORKFLOW_BLANK(formData , navigate))
    }}>
      {workflow_listing_loader? <Custom_Loader/>: <Row className="g-3">
        <Col lg={7}>
          <div className="cnbn">
            <label htmlFor="dashboardName" className="form-label">
              Workflow Title *
            </label>
            <Input
              type="text"
              className="form-control"
              id="dashboardName"
              value={dashboardName}
              onChange={(e) => setDashboardName(e.target.value)}
              required
            />
          </div>
        </Col>

        <Col lg={5}>
          <div className="text-center">
            <div className="profile-user position-relative d-inline-block mx-auto mb-4">
              <img
                src={user_avatar || avatar1}
                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                alt="user-profile"
              />
              <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                <Input
                  name="profile_image"
                  id="profile-img-file-input"
                  type="file"
                  className="profile-img-file-input"
                  accept=".jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                    if (file && allowedTypes.includes(file.type)) {
                      setuser_avatar(URL.createObjectURL(file));
                      setuser_avatar_file(file);
                      const blob = await fileToBase64(file);
                      set_dashboard_logo(JSON.stringify(blob));
                    } else {
                      alert("Please upload a valid JPG or PNG file.");
                      e.target.value = null;
                    }
                  }}
                />
                <Label htmlFor="profile-img-file-input" className="profile-photo-edit avatar-xs">
                  <span className="avatar-title rounded-circle bg-light text-body">
                    <i className="ri-camera-fill"></i>
                  </span>
                </Label>
              </div>
            </div>
          </div>
        </Col>

        <Col className="mt-1" lg={6}>
          <label htmlFor="groupSelect" className="form-label">
            Group *
          </label>
          <select
            id="groupSelect"
            className="form-select"
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            required
          >
            <option value="">Select Group</option>
            {group_details?.groupList.map((ele, i) => (
              <option key={i} value={ele.Group_ID}>
                {ele.Group_Name}
              </option>
            ))}
          </select>
        </Col>

        <Col className="mt-0" lg={6}>
          <label htmlFor="categorySelect" className="form-label">
            Category *
          </label>
          <CreatableSelect onChange={(category)=>{
            console.log(category);
            
            setworkflow_category(category.value)
          }} 
          options={workflow_category_by_group.map((ele)=>{
               return {value :ele.Workflow_Category , label:ele.Workflow_Category}
            })} placeholder="Create or Select" />
        </Col>

        <Col lg={12}>
          <div className="hstack gap-2 justify-content-center">
            <Button color="light" onClick={tog_standard}>Cancel</Button>
            <Button color="primary" type="submit">Next</Button>
          </div>
        </Col>
      </Row>}
    </Form>
  </ModalBody>
</Modal>
    </>
  );
};

export default Create_New_WorkFlow_Dashboard;
